import { useCallback, useEffect, useRef } from 'react';
import gsap from 'gsap';

// The font-morph title card. Plays once per browser session, and
// a click / tap anywhere cuts it short.
export default function Intro({ onDone }) {
    const textRef = useRef(null);
    const wrapRef = useRef(null);
    const tlRef = useRef(null);

    useEffect(() => {
        const tl = gsap.timeline({ onComplete: onDone });
        tlRef.current = tl;

        tl.fromTo(
            textRef.current,
            { scale: 0, opacity: 0 },
            { scale: 1, opacity: 1, duration: 0.75, ease: 'elastic.in' }
        )
            .to(textRef.current, { duration: 0.3, fontFamily: 'Satoshi', scale: 1.1, ease: 'sine.inOut' })
            .to(textRef.current, { duration: 0.3, fontFamily: 'Whisper', scale: 1.2, ease: 'sine.inOut' })
            .to(textRef.current, { duration: 0.3, fontFamily: 'Archivo', scale: 1.4, ease: 'sine.inOut' })
            .to(textRef.current, { duration: 0.3, fontFamily: 'Rubik Bubbles', scale: 1.2, ease: 'sine.inOut' })
            .to(textRef.current, { duration: 0.3, fontFamily: 'DM Serif Display', scale: 1.1, ease: 'sine.inOut' })
            .to(textRef.current, { duration: 0.5, fontFamily: 'Libre Baskerville', scale: 1, ease: 'sine.inOut' })
            .to(textRef.current, { duration: 0.8 })
            // Dissolve the whole card with the name still on it, so the hero
            // is revealed underneath in one continuous move. Fading the text
            // out first left a blank gap, after which the hero's name faded
            // in separately -- which read as the intro playing a second time.
            .to(wrapRef.current, { opacity: 0, duration: 1.1 });

        // rAF is throttled in background tabs, which stalls the timeline and
        // would leave the page stuck behind this card. Timers still fire, so
        // this guarantees the site is reachable either way.
        const bail = setTimeout(onDone, 9000);

        return () => {
            clearTimeout(bail);
            tl.kill();
        };
    }, [onDone]);

    const skip = useCallback(() => {
        tlRef.current?.kill();
        onDone();
    }, [onDone]);

    return (
        <div
            ref={wrapRef}
            onClick={skip}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') skip(); }}
            role="button"
            tabIndex={0}
            aria-label="Skip intro animation"
            className="fixed inset-0 z-50 bg-white flex items-center justify-center cursor-pointer px-6"
        >
            <div ref={textRef} className="text-4xl text-d-green text-center">
                Robby Rice
            </div>
        </div>
    );
}
